// extracted by mini-css-extract-plugin
export default {"fab":"FilterFab_fab__DHEjs"};